import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as actions from '../actions/micustomeractions'
import * as appConstants from './../../../overrides/appconstants'
import PlanCompare from './PlanCompare';
import {
    Button,
    Box,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import * as appActions from '../../../actions/appactions';
import * as reportActions from '../../reportengine/actions/reportengineactions'
import * as appUtilityFunctions from '../../../infrastructure/apputilityfunctions'
import PlanTOB from './PlanTOB';
import PaymentsIcon from '@mui/icons-material/Payments';
import PolicyIcon from '@mui/icons-material/Policy';
import DownloadIcon from '@mui/icons-material/Download';

export default function ProductSelection({ section }) {
    const state = useSelector(state => state.miCustomerSharedReducer);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let productSelection = state.productSelection;
    let memberBasePrem = state.membersBasePremiumRates;
    // let planSelection = state.planSelection;
    let indicativeMemberList = state.indicativeQuote.memberList;
    let activeStep = state.activeStep;
    let modalState = state.modalState;
    let masters = state.masters;
    let individualPlansTOB = state.individualPlansTOB;
    let basicInfoNewEnq = state.basicInfoNewEnq;
    const refPlanCompare = useRef(null);
    const refBasePremuimBreak = useRef(null);
    const refPlanTob = useRef(null);
    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm();

    useEffect(() => {
        reset();

        const getProductPlanByVisaEmirateIdForIndicativeQuote = async () => {
            await dispatch(actions.getProductPlanByVisaEmirateIdForIndicativeQuote(basicInfoNewEnq?.visaEmirate));
        }

        if (basicInfoNewEnq?.visaEmirate != null && basicInfoNewEnq?.visaEmirate != "") {
            getProductPlanByVisaEmirateIdForIndicativeQuote();
        }
    }, []);

    useEffect(() => {
        let valuesToMap = [
            { "visaEmirate": productSelection.visaEmirate },
            { "planType": productSelection.planType },
            { "networkType": productSelection.networkType }
        ];
        valuesToMap.forEach(i => Object.keys(i).forEach(key => setValue(key, i[key])));
    }, [productSelection]);


    const handleBack = () => {
        dispatch(actions.handleNextStep(1))
    }
    const updatePlanParams = () => {



    }

    const onSubmit = async (data) => {

        await dispatch(actions.savePlanDetails(!basicInfoNewEnq?.isRefertoUW && !basicInfoNewEnq?.isPolicyIssued))

    }
    const onErrors = async (data) => {
    }
    const closeModal = () => {
        dispatch(actions.toggleBasePremModel(false))
    }
    const closetobModal = () => {
        dispatch(actions.togglePlanTOBModel(false))
    }
    // let reportEngineUiParams =
    // {
    //     "QUOTATION_ID": policyInformation.policyId
    // };
    function showReport(quoteId) {
        let options = {
            reportTitle: "Indicative Quote",
            systemId: appConstants.SYSTEM_ID,
            moduleId: appConstants.MODULE_ID_INDIVIDUAL_QUOTATION,
            pageId: appConstants.PAGE_MENU_ID_INDICATIVE_QUOTE,
            uiParams: {
                "QUOTATION_ID": quoteId,
                "VISAEMIRATEID": productSelection.visaEmirate,
                "PORTAL_PLAN_TYPE_ID": productSelection.planType
            },

        }
        dispatch(reportActions.showReports(options));
    }
    const handleProductSelectionChange = async (e) => {
        let { name, value } = e.target;
        if (name == "networkType") {
            value = value === "" ? null : Number(value);
            await dispatch(actions.updateProductSelectionParams({ name, value }));

            await dispatch(actions.getPlanTypeByNetId(value))
            await dispatch(actions.getProductPlanByVisaEmirateIdForIndicativeQuote(state.basicInfoNewEnq?.visaEmirate, value));
            let namee = 'planType'
            await dispatch(actions.updateProductSelectionParams({ name: namee, value: null }));

            return;
        }
        await dispatch(actions.updateProductSelectionParams({ name, value }));
        if (name == "visaEmirate") {
            // if (section == appConstants.SECTION_INDICATIVE_QUOTE) {
            await dispatch(actions.getProductPlanByVisaEmirateIdForIndicativeQuote(value));
            // } 
            // else {
            //     await dispatch(actions.getProductPlanByVisaEmirateId());
            // }
        }
        // if (name == "visaEmirate" && section == appConstants.SECTION_NORMAL_QUOTE) {
        //     await dispatch(miBrokerActions.getProductsByVisaEmirateId(value));
        //     await dispatch(miBrokerActions.updateQuotationInformationParams(name, value));

        // }
        if ((name == "visaEmirate") && section == appConstants.SECTION_INDICATIVE_QUOTE) {
            await dispatch(actions.updateIndicativeQuoteParams({ name, value }));
        }
        await dispatch(actions.uncheckAllSelctedPlanInProductSelecction());
        await dispatch(actions.toggleBasePremModel(false))
        await dispatch(actions.togglePlanTOBModel(false))


    }
    // const onCloseModal = async (e) => {
    //     await onResetProductSelection();
    //     let name = "showProductSelectionModel";
    //     let value = false;
    //     await dispatch(miBrokerActions.updateMiBrokerModalsStateParams({ name, value }));



    // }

    const onDisplayCurrentPlanTOB = async (planId, planName, productName) => {
        await dispatch(actions.getProductPlanTOBByPlanId(planId));
        {
            let name = "planName";
            let value = planName;
            await dispatch(actions.updatePlanTOBParams({ name, value }));
        }
        {

            let name = "productName";
            let value = productName;
            await dispatch(actions.updatePlanTOBParams({ name, value }));

            scrolltoTob();
        }
    }
    const onDownloadTOBFile = async (fileName) => {
        if (fileName == null) {
            dispatch(appActions.showMessage("TOB Not available"));
            return;
        }
        window.open(`https://static1.alsagrins.ae/med/tob/${fileName}`, '_blank').focus();
        return;
    }

    const onDownloadNetFile = async (fileName) => {
        if (fileName == null) {
            dispatch(appActions.showMessage("Network File Not available"));
            return;
        }
        window.open(`https://static1.alsagrins.ae/med/networks/${fileName}`, '_blank').focus();
        return;
    }
    const handlePlansCheckboxChange = (e, planId, planTypeId) => {

        let { name, value, checked } = e.target;
        if (checked) {

            dispatch(actions.updateProductSelectionParams({ name: 'planType', value: planTypeId }));

        }
        else {
            dispatch(actions.updateProductSelectionParams({ name: 'planType', value: null }));

        }
        dispatch(actions.updateProductSelectionCheckboxParams(checked, planId));
    }
    // const getQuote = async (plan) => {
    //     if (section == appConstants.SECTION_NORMAL_QUOTE) {
    //         if (plan == appConstants.PORTAL_PLAN_TYPE_ID_ESSENTIAL_PLANS) {
    //             // var currentPlanList = (state.planSelection.plansList).slice();
    //             // let index = currentPlanList.findIndex(p => p.planId == action.payload.planId);

    //             let plans = productSelection.plansList.filter(p => p.portalPlanTypeId == plan);
    //             let checkedPlan = plans.filter(p => p.isChecked == true);
    //             if (checkedPlan.length == 0) {
    //                 dispatch(appActions.showMessage("Please Choose ASASI EMPLOYEE or ASASI DEPENDENTS Plan!", { buttons: ['Close'] }));
    //                 return;
    //             }
    //             if (checkedPlan.length > 1) {
    //                 dispatch(appActions.showMessage("Please Select Only One Plan!", { buttons: ['Close'] }));
    //                 return;
    //             }
    //             if (checkedPlan.length == 1) {
    //                 let product = checkedPlan[0].productId
    //                 let name = "product"
    //                 let value = product
    //                 await dispatch(miBrokerActions.updateQuotationInformationParams(name, value));
    //                 {
    //                     let name = "portalPlanType"
    //                     let value = plan
    //                     await dispatch(miBrokerActions.updateQuotationInformationParams(name, value));
    //                 }
    //             }
    //             await onCloseModal();

    //             //isChecked
    //         }
    //         else if (plan == appConstants.PORTAL_PLAN_TYPE_ID_BASIC_PLANS) {
    //             // var currentPlanList = (state.planSelection.plansList).slice();
    //             // let index = currentPlanList.findIndex(p => p.planId == action.payload.planId);

    //             let plans = productSelection.plansList.filter(p => p.portalPlanTypeId == plan);
    //             let checkedPlan = plans.filter(p => p.isChecked == true);
    //             if (checkedPlan.length == 0) {
    //                 dispatch(appActions.showMessage("Please Choose One Plan!", { buttons: ['Close'] }));
    //                 return;
    //             }
    //             if (checkedPlan.length > 1) {
    //                 dispatch(appActions.showMessage("Please Select Only One Plan!", { buttons: ['Close'] }));
    //                 return;
    //             }
    //             if (checkedPlan.length == 1) {
    //                 let product = checkedPlan[0].productId
    //                 let name = "product"
    //                 let value = product
    //                 await dispatch(miBrokerActions.updateQuotationInformationParams(name, value));
    //                 {
    //                     let name = "portalPlanType"
    //                     let value = plan
    //                     await dispatch(miBrokerActions.updateQuotationInformationParams(name, value));
    //                 }
    //             }
    //             await onCloseModal();

    //             //isChecked
    //         }


    //         else {


    //             let plans = productSelection.plansList.filter(p => p.portalPlanTypeId == plan);
    //             let product = plans[0].productId
    //             let name = "product"
    //             let value = product
    //             await dispatch(miBrokerActions.updateQuotationInformationParams(name, value));
    //             {
    //                 let name = "portalPlanType"
    //                 let value = plan
    //                 await dispatch(miBrokerActions.updateQuotationInformationParams(name, value));
    //             }
    //             await onCloseModal();
    //         }
    //     }
    // }
    const onPlansComparison = async () => {
        await dispatch(actions.getBenefitStructureByPlanIds());
        scrollToPlanCompare();
    }

    const scrollToPlanCompare = () => {
        refPlanCompare.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToBasePremBreak = () => {
        refBasePremuimBreak.current?.scrollIntoView({ behavior: 'smooth' });
    };
    const scrolltoTob = () => {
        refPlanTob.current?.scrollIntoView({ behavior: 'smooth' });
    };
    const onResetProductSelection = (e) => {

        reset();
        dispatch(actions.resetProductSelection());
    }

    const saveIndicativeQuote = async () => {
        let quoteId = await dispatch(actions.saveIndicativeQuote(section));
        if (quoteId != false && quoteId != null) {
            await showReport(quoteId)
        }
    }

    const onDisplayCurrentBasePremium = async (planId, productId) => {

        await dispatch(actions.getMembersBasePremiumByPlan(planId, productId));
        scrollToBasePremBreak();


    }
    const handleCheckBox = (e, planTypeId, productId) => {

        let { id, checked } = e.target;


        dispatch(actions.updatePlanSelection({ checked, id, productId }));


    }

    function renderProductSelectionForIndicativeQuote() {
        let VisaEmirate =
            <select className={errors.visaEmirate ? 'form-select is-invalid' : 'form-select'}
                data-toggle="select2"
                id="visaEmirate"
                name="visaEmirate"
                {...register("visaEmirate",
                    { required: true, onChange: (e) => handleProductSelectionChange(e) })}
                value={productSelection.visaEmirate}
            >
                <option value="">-- Select Visa Emirate --</option>
                {masters.visaEmirateMasters.filter(emirate => !appConstants.VISA_EMIRATE_COUNTRY.includes(emirate.domainValue)
                ).map((res, index) => (
                    <option value={res.id} key={res.id}>
                        {res.name}
                    </option>
                ))}
            </select>
        let PlanType =
            <select className={errors.planType ? 'form-select is-invalid' : 'form-select'}
                data-toggle="select2"
                id="planType"
                name="planType"
                {...register("planType",
                    { required: true, onChange: (e) => handleProductSelectionChange(e) })}
                value={productSelection.planType}
            >
                <option value="">-- Select Plan Type --</option>
                {masters.portalPlanTypeMastersFilterd.filter(m => productSelection.plansList.map(p => p.portalPlanTypeId).includes(m.domainValue)).map((portalPlanType, index) => (
                    <option value={portalPlanType.domainValue} key={portalPlanType.domainValue}>
                        {portalPlanType.domainValueName}
                    </option>
                ))}
            </select>
        return (
            <>

                {/* <ul className="nav nav-tabs nav-bordered mb-1">
                </ul> */}

                <div className="collapse show" id="CollapseBenefitComparison">
                    <div className="row g-2">
                        <div className="mt-3 col-md-12">
                            <div className="btn-grczoup float-end" id="tooltip-container2">
                                <div class="btn-group me-1" role="group" aria-label="Second group">
                                    {/* data-bs-toggle="modal"
                                id="individualBenefitStructure1" data-bs-target="#individualBenefitStructure" */}
                                    {//checkPermissions.hasAddQuotation &&
                                        <button type="button" className="btn" style={{ backgroundColor: '#ffa500' }}
                                            title=" Compare Plans" onClick={() => onPlansComparison()}>
                                            <i className="mdi mdi-compare-horizontal"></i>   Compare Plans
                                        </button>
                                    }

                                </div>
                                {//checkPermissions.hasResetQuotationSearch &&
                                    <button type="button" className="btn btn-danger"
                                        data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Reset" onClick={() => onResetProductSelection()}> Reset <i className="mdi mdi-rotate-left"></i>
                                    </button>

                                }
                            </div>
                        </div>
                    </div>
                    {
                        <div className="row g-2">
                            <div className="mb-3 col-md-3">
                                <label htmlFor="inputPassword4" className="form-label"><span className='redstar'>*</span>  Visa Emirate</label>
                                {VisaEmirate}
                            </div>
                            <div className="mb-3 col-md-3">
                                <label htmlFor="inputPassword4" className="form-label"><span className='redstar'>*</span> Plan Type</label>
                                {PlanType}
                            </div>
                        </div>
                    }
                    {/* {renderExecutivePlans()}
                    {renderStandardPlans()} */}
                    {productSelection.visaEmirate && <div>

                        {productSelection.plansList.filter(p => p.portalPlanTypeId == appConstants.PORTAL_PLAN_TYPE_ID_EXECUTIVE_PLANS && (p.portalPlanTypeId == productSelection.planType || productSelection.planType == "" || productSelection.planType == null)).length > 0 &&
                            <div>
                                <div className="ribbon ribbon-primary float-start"><i className="dripicons-information  me-1"></i>Executive Plans</div>
                                {renderExecutivePlans()}
                            </div>
                        }
                        {productSelection.plansList.filter(p => p.portalPlanTypeId == appConstants.PORTAL_PLAN_TYPE_ID_STANDARD_PLANS && (p.portalPlanTypeId == productSelection.planType || productSelection.planType == "" || productSelection.planType == null)).length > 0 &&
                            <div>
                                <div className="ribbon ribbon-primary float-start"><i className="dripicons-information -3 me-1"></i>Standard Plans</div>
                                {renderStandardPlans()}
                            </div>
                        }
                        {productSelection.plansList.filter(p => p.portalPlanTypeId == appConstants.PORTAL_PLAN_TYPE_ID_ESSENTIAL_PLANS && (p.portalPlanTypeId == productSelection.planType || productSelection.planType == "" || productSelection.planType == null)).length > 0 &&
                            <div>
                                <div className="ribbon ribbon-primary float-start"><i className="dripicons-information me-1"></i>Essential Plans</div>
                                {renderEssentialPlans()}
                            </div>
                        }
                        {productSelection.plansList.filter(p => p.portalPlanTypeId == appConstants.PORTAL_PLAN_TYPE_ID_LIMITED_PLANS && (p.portalPlanTypeId == productSelection.planType || productSelection.planType == "" || productSelection.planType == null)).length > 0 &&
                            <div>
                                <div className="ribbon ribbon-primary float-start"><i className="dripicons-information me-1"></i>Limited Plans</div>
                                {renderLimitedPlans()}
                            </div>
                        }
                        {productSelection.plansList.filter(p => p.portalPlanTypeId == appConstants.PORTAL_PLAN_TYPE_ID_BASIC_PLANS && (p.portalPlanTypeId == productSelection.planType || productSelection.planType == "" || productSelection.planType == null)).length > 0 &&
                            <div>
                                <div className="ribbon ribbon-primary float-start"><i className="dripicons-information me-1"></i>Basic Plans</div>
                                {renderBasicPlans()}
                            </div>
                        }

                        {//censusData.memberImportFileCheck &&

                            <div className="btn-group float-end" id="tooltip-container2">
                                {/*checkPermissions.hasProceedMemberImport &&*/
                                    <button type="button" className="btn btn-success" data-bs-dismiss="modal" aria-hidden="true" data-bs-container="#tooltip-container2"
                                        data-bs-toggle="tooltip" data-bs-placement="bottom" title="Proceed" onClick={() => saveIndicativeQuote()}>
                                        <i className="mdi mdi-file-move"></i> Save
                                    </button>
                                }
                                {/*//checkPermissions.hasCancelMemberImport &&
                                    <button type="button" className=" btn btn-danger" data-bs-dismiss="modal" aria-hidden="true" onClick={(e) => showReport(e)}>
                                        <i className="dripicons-print"></i> Print
                                    </button>
                            */}

                            </div>
                        }
                    </div>}

                </div>

            </>
        )
    }
    function renderExecutivePlans() {
        let currentPlans = productSelection.plansList.filter(p => p.portalPlanTypeId == appConstants.PORTAL_PLAN_TYPE_ID_EXECUTIVE_PLANS);
        let isRestricted = currentPlans.filter(p => p.isRestricted == false).length == 0 && currentPlans.filter(p => p.isRestricted == false).length != undefined;

        return (<>
            {/* <ul className="nav nav-tabs nav-bordered mb-1">
            </ul> */}

            <div className="collapse show" id="CollapseBasicPlans">

                <div className="row g-2">
                    <div className="mb-1 col-md-8">
                        {currentPlans.length == 0 && <h5 className="alert alert-danger">No Plans Found...</h5>}
                    </div>

                </div>
                <div className="row g-2">
                    <div className="mb-1 col-md-12">
                        <div className="btn-group float-end" id="tooltip-container2">

                            {/* {//checkPermissions.hasPrintQuotation &&
                                section == appConstants.SECTION_NORMAL_QUOTE &&
                                (currentPlans.length > 0) &&
                                <button type="button" className="btn btn-info" data-bs-container="#tooltip-container2"
                                    data-bs-toggle="tooltip" data-bs-placement="bottom" title="Print" disabled={isRestricted} onClick={() => getQuote(appConstants.PORTAL_PLAN_TYPE_ID_EXECUTIVE_PLANS)}>
                                    <i className="uil-receipt" ></i> Get Quote
                                </button>
                            } */}
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    {(currentPlans.length > 0) && <div className="table table-responsive table-centered mb-0">
                        <table id="scroll-horizontal-datatable" className="table table-bordered w-100 nowrap resizeable_table_head">
                            <thead className="table-primary">
                                <tr>
                                    <th className="text-center"></th>
                                    <th className="text-center">S No.</th>
                                    <th className="text-center">Plan</th>
                                    <th className="text-center">Plan Type</th>
                                    {section == appConstants.SECTION_INDICATIVE_QUOTE && <th className="text-center">Base Premium</th>}
                                    {/* <th className="text-center">Premium</th> */}
                                    {/* <th className="text-center">View TOB</th> */}
                                    <th className="text-center">Actions</th>

                                </tr>
                            </thead>

                            <tbody>
                                {currentPlans.map((result, index) => (
                                    <tr /*key={benefits.quoteCategoryBenefitId}*/ >
                                        <td >
                                            {<div className="text-center" id="Check1">
                                                <input type="checkbox" id={1} className="form-check-input"
                                                    checked={result.isChecked}
                                                    disabled={result.isRestricted}
                                                    onChange={value => handlePlansCheckboxChange(value, result.planId, result.portalPlanTypeId)}
                                                    value={1} />
                                            </div>}
                                        </td>
                                        <td> {(Number(index) + Number(1))} </td>
                                        <td> {result.planCode} - {result.planDescription}</td>
                                        <td> {result.planTypeName}  </td>
                                        {section == appConstants.SECTION_INDICATIVE_QUOTE && <td> {result.basePremium} </td>}
                                        {/* <td> {result.Premium}</td> */}
                                        <td className="text-center">
                                            <div className='btn-group'>
                                                <button type="button" className="btn btn-secondary btn-sm" data-bs-container="#tooltip-container2"
                                                    data-bs-placement="bottom"
                                                    data-bs-toggle="modal" id="individualPlanTobModal1" data-bs-target="#individualPlanTobModal"
                                                    title="View TOB"
                                                    disabled={result.isRestricted}
                                                    onClick={() => onDisplayCurrentPlanTOB(result.planId, result.planName, result.productName)}>
                                                    <i className="dripicons-preview"></i>
                                                </button>
                                                {section == appConstants.SECTION_INDICATIVE_QUOTE
                                                    && (indicativeMemberList.length > 1 || (indicativeMemberList.length == 1 && indicativeMemberList[0].memberFirstName != null))

                                                    &&
                                                    <button type="button" className="btn btn-primary btn-sm" data-bs-container="#tooltip-container2"
                                                        data-bs-placement="bottom"
                                                        data-bs-toggle="modal" id="memberBasePremiumModalId" data-bs-target="#memberBasePremiumModal"
                                                        title="View Base Premium"
                                                        disabled={result.isRestricted}
                                                        onClick={() => onDisplayCurrentBasePremium(result.planId, result.productId)}>
                                                        <i className="mdi mdi-cash"></i>
                                                    </button>}
                                                <button type="button" className="btn btn-info btn-sm" data-bs-container="#tooltip-container2"
                                                    data-bs-placement="bottom"
                                                    data-bs-toggle="modal" /* id="individualPlanTobModal1465f65s465" data-bs-target="#individualPlanTobModal1465f65s465" */
                                                    title="Download TOB"
                                                    disabled={result.isRestricted}
                                                    onClick={() => onDownloadTOBFile(result?.tobFileName ?? null)}>
                                                    <i className="mdi mdi-download"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>))}

                            </tbody>
                        </table>
                    </div>}
                </div>

            </div>

        </>)
    }
    function renderStandardPlans() {
        let currentPlans = productSelection.plansList.filter(p => p.portalPlanTypeId == appConstants.PORTAL_PLAN_TYPE_ID_STANDARD_PLANS);
        let isRestricted = currentPlans.filter(p => p.isRestricted == false).length == 0 && currentPlans.filter(p => p.isRestricted == false).length != undefined;

        return (<>
            {/* <ul className="nav nav-tabs nav-bordered mb-1">
            </ul> */}

            <div className="collapse show" id="CollapseBasicPlans">

                <div className="row g-2">
                    <div className="mb-1 col-md-8">
                        {currentPlans.length == 0 && <h5 className="alert alert-danger">No Plans Found...</h5>}
                    </div>

                </div>
                <div className="row g-2">
                    <div className="mb-1 col-md-12">
                        <div className="btn-group float-end" id="tooltip-container2">

                            {/* {//checkPermissions.hasPrintQuotation &&
                                (currentPlans.length > 0) &&
                                section == appConstants.SECTION_NORMAL_QUOTE &&
                                <button type="button" className="btn btn-info" data-bs-container="#tooltip-container2"
                                    data-bs-toggle="tooltip" data-bs-placement="bottom" title="Print" disabled={isRestricted} onClick={() => getQuote(appConstants.PORTAL_PLAN_TYPE_ID_STANDARD_PLANS)}>
                                    <i className="uil-receipt" ></i> Get Quote
                                </button>
                            } */}
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    {(currentPlans.length > 0) && <div className="table table-responsive table-centered mb-0">
                        <table id="scroll-horizontal-datatable" className="table table-bordered w-100 nowrap resizeable_table_head">
                            <thead className="table-primary">
                                <tr>
                                    <th className="text-center"></th>
                                    <th className="text-center">S No.</th>
                                    <th className="text-center">Plan</th>
                                    <th className="text-center">Plan Type</th>
                                    {section == appConstants.SECTION_INDICATIVE_QUOTE && <th className="text-center">Base Premium</th>}

                                    {/* <th className="text-center">Premium</th> */}
                                    <th className="text-center">Actions</th>

                                </tr>
                            </thead>

                            <tbody>
                                {currentPlans.map((result, index) => (
                                    <tr /*key={benefits.quoteCategoryBenefitId}*/ >
                                        <td >
                                            {<div className="text-center" id="Check1">
                                                <input type="checkbox" id={1} className="form-check-input"
                                                    checked={result.isChecked}
                                                    disabled={result.isRestricted}
                                                    onChange={value => handlePlansCheckboxChange(value, result.planId)}
                                                    value={1} />
                                            </div>}
                                        </td>
                                        <td> {(Number(index) + Number(1))} </td>
                                        <td> {result.planCode} - {result.planDescription}</td>
                                        <td> {result.planTypeName}</td>
                                        {section == appConstants.SECTION_INDICATIVE_QUOTE && <td> {result.basePremium} </td>}
                                        {/* <td> {result.Premium}</td> */}
                                        <td className="text-center">
                                            <div className='btn-group'>
                                                <button type="button" className="btn btn-secondary btn-sm" data-bs-container="#tooltip-container2"
                                                    data-bs-placement="bottom"
                                                    data-bs-toggle="modal" id="individualPlanTobModal1" data-bs-target="#individualPlanTobModal"
                                                    title="View TOB"
                                                    disabled={result.isRestricted}
                                                    onClick={() => onDisplayCurrentPlanTOB(result.planId, result.planName, result.productName)}>
                                                    <i className="dripicons-preview"></i>
                                                </button>
                                                {section == appConstants.SECTION_INDICATIVE_QUOTE && (indicativeMemberList.length > 1 || (indicativeMemberList.length == 1 && indicativeMemberList[0].memberFirstName != null)) &&
                                                    <button type="button" className="btn btn-primary btn-sm" data-bs-container="#tooltip-container2"
                                                        data-bs-placement="bottom"
                                                        data-bs-toggle="modal" id="memberBasePremiumModalId" data-bs-target="#memberBasePremiumModal"
                                                        title="View Base Premium"
                                                        disabled={result.isRestricted}
                                                        onClick={() => onDisplayCurrentBasePremium(result.planId, result.productId)}>
                                                        <i className="mdi mdi-cash"></i>
                                                    </button>}
                                                <button type="button" className="btn btn-info btn-sm" data-bs-container="#tooltip-container2"
                                                    data-bs-placement="bottom"
                                                    data-bs-toggle="modal" /* id="individualPlanTobModal1465f65s465" data-bs-target="#individualPlanTobModal1465f65s465" */
                                                    title="Download TOB"
                                                    disabled={result.isRestricted}
                                                    onClick={() => onDownloadTOBFile(result?.tobFileName ?? null)}>
                                                    <i className="mdi mdi-download"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>))}

                            </tbody>
                        </table>
                    </div>}
                </div>

            </div>

        </>)
    }
    function renderEssentialPlans() {
        let currentPlans = productSelection.plansList.filter(p => p.portalPlanTypeId == appConstants.PORTAL_PLAN_TYPE_ID_ESSENTIAL_PLANS);
        let isRestricted = currentPlans.filter(p => p.isRestricted == false).length == 0 && currentPlans.filter(p => p.isRestricted == false).length != undefined;
        console.log("essential", isRestricted)

        return (<>
            {/* <ul className="nav nav-tabs nav-bordered mb-1">
            </ul> */}

            <div className="collapse show" id="CollapseBasicPlans">

                <div className="row g-2">
                    <div className="mb-1 col-md-8">
                        {currentPlans.length == 0 && <h5 className="alert alert-danger">No Plans Found...</h5>}
                    </div>

                </div>
                <div className="row g-2">
                    <div className="mb-1 col-md-12">
                        <div className="btn-group float-end" id="tooltip-container2">

                            {/* {//checkPermissions.hasPrintQuotation &&
                                (currentPlans.length > 0) &&
                                section == appConstants.SECTION_NORMAL_QUOTE &&
                                <button type="button" className="btn btn-info" data-bs-container="#tooltip-container2"
                                    data-bs-toggle="tooltip" data-bs-placement="bottom" title="Print" disabled={isRestricted} onClick={() => getQuote(appConstants.PORTAL_PLAN_TYPE_ID_ESSENTIAL_PLANS)}>
                                    <i className="uil-receipt" ></i> Get Quote
                                </button>
                            } */}
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    {(currentPlans.length > 0) && <div className="table table-responsive table-centered mb-0">
                        <table id="scroll-horizontal-datatable" className="table table-bordered w-100 nowrap resizeable_table_head">
                            <thead className="table-primary">
                                <tr>
                                    <th className="text-center"></th>
                                    <th className="text-center">S No.</th>
                                    <th className="text-center">Plan</th>
                                    <th className="text-center">Plan Type</th>
                                    {section == appConstants.SECTION_INDICATIVE_QUOTE && <th className="text-center">Base Premium</th>}

                                    {/* <th className="text-center">Premium</th> */}
                                    <th className="text-center">Actions</th>

                                </tr>
                            </thead>

                            <tbody>
                                {currentPlans.map((result, index) => (
                                    <tr /*key={benefits.quoteCategoryBenefitId}*/ >
                                        <td >
                                            {<div className="text-center" id="Check1">
                                                <input type="checkbox" id={1} className="form-check-input"
                                                    checked={result.isChecked}
                                                    disabled={result.isRestricted}
                                                    onChange={value => handlePlansCheckboxChange(value, result.planId)}
                                                    value={1} />
                                            </div>}
                                        </td>
                                        <td> {(Number(index) + Number(1))} </td>
                                        <td> {result.planCode} - {result.planDescription}</td>
                                        <td> {result.planTypeName}</td>
                                        {section == appConstants.SECTION_INDICATIVE_QUOTE && <td> {result.basePremium} </td>}
                                        {/* <td> {result.Premium}</td> */}
                                        <td className="text-center">
                                            <div className='btn-group'>
                                                <button type="button" className="btn btn-secondary btn-sm"
                                                    data-bs-toggle="modal" id="individualPlanTobModal1" data-bs-target="#individualPlanTobModal"
                                                    title="View TOB"
                                                    disabled={result.isRestricted}
                                                    onClick={() => onDisplayCurrentPlanTOB(result.planId, result.planName, result.productName)}>
                                                    <i className="dripicons-preview"></i>
                                                </button>
                                                {section == appConstants.SECTION_INDICATIVE_QUOTE && (indicativeMemberList.length > 1 || (indicativeMemberList.length == 1 && indicativeMemberList[0].memberFirstName != null)) &&
                                                    <button type="button" className="btn btn-primary btn-sm" data-bs-container="#tooltip-container2"
                                                        data-bs-placement="bottom"
                                                        data-bs-toggle="modal" id="memberBasePremiumModalId" data-bs-target="#memberBasePremiumModal"
                                                        title="View Base Premium"
                                                        disabled={result.isRestricted}
                                                        onClick={() => onDisplayCurrentBasePremium(result.planId, result.productId)}>
                                                        <i className="mdi mdi-cash"></i>
                                                    </button>}
                                                <button type="button" className="btn btn-info btn-sm" data-bs-container="#tooltip-container2"
                                                    data-bs-placement="bottom"
                                                    data-bs-toggle="modal" /* id="individualPlanTobModal1465f65s465" data-bs-target="#individualPlanTobModal1465f65s465" */
                                                    title="Download TOB"
                                                    disabled={result.isRestricted}
                                                    onClick={() => onDownloadTOBFile(result?.tobFileName ?? null)}>
                                                    <i className="mdi mdi-download"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>))}

                            </tbody>
                        </table>
                    </div>}
                </div>

            </div>

        </>)
    }
    function renderLimitedPlans() {
        let currentPlans = productSelection.plansList.filter(p => p.portalPlanTypeId == appConstants.PORTAL_PLAN_TYPE_ID_LIMITED_PLANS);
        let isRestricted = currentPlans.filter(p => p.isRestricted == false).length == 0 && currentPlans.filter(p => p.isRestricted == false).length != undefined;

        return (<>
            {/* <ul className="nav nav-tabs nav-bordered mb-1">
            </ul> */}

            <div className="collapse show" id="CollapseBasicPlans">

                <div className="row g-2">
                    <div className="mb-1 col-md-8">
                        {currentPlans.length == 0 && <h5 className="alert alert-danger">No Plans Found...</h5>}
                    </div>

                </div>
                <div className="row g-2">
                    <div className="mb-1 col-md-12">
                        <div className="btn-group float-end" id="tooltip-container2">

                            {/* {//checkPermissions.hasPrintQuotation &&
                                (currentPlans.length > 0) &&
                                section == appConstants.SECTION_NORMAL_QUOTE &&
                                <button type="button" className="btn btn-info" data-bs-container="#tooltip-container2"
                                    data-bs-toggle="tooltip" data-bs-placement="bottom" title="Print" disabled={isRestricted} onClick={() => getQuote(appConstants.PORTAL_PLAN_TYPE_ID_LIMITED_PLANS)}>
                                    <i className="uil-receipt" ></i> Get Quote
                                </button>
                            } */}
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    {(currentPlans.length > 0) && <div className="table table-responsive table-centered mb-0">
                        <table id="scroll-horizontal-datatable" className="table table-bordered w-100 nowrap resizeable_table_head">
                            <thead className="table-primary">
                                <tr>
                                    <th className="text-center"></th>
                                    <th className="text-center">S No.</th>
                                    <th className="text-center">Plan</th>
                                    <th className="text-center">Plan Type</th>
                                    {section == appConstants.SECTION_INDICATIVE_QUOTE && <th className="text-center">Base Premium</th>}

                                    {/* <th className="text-center">Premium</th> */}
                                    <th className="text-center">Actions</th>

                                </tr>
                            </thead>

                            <tbody>
                                {currentPlans.map((result, index) => (
                                    <tr /*key={benefits.quoteCategoryBenefitId}*/ >
                                        <td >
                                            {<div className="text-center" id="Check1">
                                                <input type="checkbox" id={1} className="form-check-input"
                                                    checked={result.isChecked}
                                                    disabled={result.isRestricted}
                                                    onChange={value => handlePlansCheckboxChange(value, result.planId)}
                                                    value={1} />
                                            </div>}
                                        </td>
                                        <td> {(Number(index) + Number(1))} </td>
                                        <td> {result.planCode} - {result.planDescription}</td>
                                        <td> {result.planTypeName}</td>
                                        {section == appConstants.SECTION_INDICATIVE_QUOTE && <td> {result.basePremium} </td>}
                                        {/* <td> {result.Premium}</td> */}
                                        <td className="text-center">
                                            <div className='btn-group'>
                                                <button type="button" className="btn btn-secondary btn-sm"
                                                    data-bs-toggle="modal" id="individualPlanTobModal1" data-bs-target="#individualPlanTobModal"
                                                    title="View TOB"
                                                    disabled={result.isRestricted}
                                                    onClick={() => onDisplayCurrentPlanTOB(result.planId, result.planName, result.productName)}>
                                                    <i className="dripicons-preview"></i>
                                                </button>
                                                {section == appConstants.SECTION_INDICATIVE_QUOTE && (indicativeMemberList.length > 1 || (indicativeMemberList.length == 1 && indicativeMemberList[0].memberFirstName != null)) &&
                                                    <button type="button" className="btn btn-primary btn-sm" data-bs-container="#tooltip-container2"
                                                        data-bs-placement="bottom"
                                                        data-bs-toggle="modal" id="memberBasePremiumModalId" data-bs-target="#memberBasePremiumModal"
                                                        title="View Base Premium"
                                                        disabled={result.isRestricted}
                                                        onClick={() => onDisplayCurrentBasePremium(result.planId, result.productId)}>
                                                        <i className="mdi mdi-cash"></i>
                                                    </button>}
                                                <button type="button" className="btn btn-info btn-sm" data-bs-container="#tooltip-container2"
                                                    data-bs-placement="bottom"
                                                    data-bs-toggle="modal" /* id="individualPlanTobModal1465f65s465" data-bs-target="#individualPlanTobModal1465f65s465" */
                                                    title="Download TOB"
                                                    disabled={result.isRestricted}
                                                    onClick={() => onDownloadTOBFile(result?.tobFileName ?? null)}>
                                                    <i className="mdi mdi-download"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>))}

                            </tbody>
                        </table>
                    </div>}
                </div>

            </div>

        </>)
    }
    function renderBasicPlans() {
        let currentPlans = productSelection.plansList.filter(p => p.portalPlanTypeId == appConstants.PORTAL_PLAN_TYPE_ID_BASIC_PLANS);
        let isRestricted = currentPlans.filter(p => p.isRestricted == false).length == 0 && currentPlans.filter(p => p.isRestricted == false).length != undefined;

        return (<>
            {/* <ul className="nav nav-tabs nav-bordered mb-1">
            </ul> */}

            <div className="collapse show" id="CollapseBasicPlans">

                <div className="row g-2">
                    <div className="mb-1 col-md-8">
                        {currentPlans.length == 0 && <h5 className="alert alert-danger">No Plans Found...</h5>}
                    </div>

                </div>
                <div className="row g-2">
                    <div className="mb-1 col-md-12">
                        <div className="btn-group float-end" id="tooltip-container2">

                            {/* {//checkPermissions.hasPrintQuotation &&
                                (currentPlans.length > 0) &&
                                section == appConstants.SECTION_NORMAL_QUOTE &&
                                <button type="button" className="btn btn-info" data-bs-container="#tooltip-container2"
                                    data-bs-toggle="tooltip" data-bs-placement="bottom" title="Print" disabled={isRestricted} onClick={() => getQuote(appConstants.PORTAL_PLAN_TYPE_ID_BASIC_PLANS)}>
                                    <i className="uil-receipt" ></i> Get Quote
                                </button>
                            } */}
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    {(currentPlans.length > 0) && <div className="table table-responsive table-centered mb-0">
                        <table id="scroll-horizontal-datatable" className="table table-bordered w-100 nowrap resizeable_table_head">
                            <thead className="table-primary">
                                <tr>
                                    <th className="text-center"></th>
                                    <th className="text-center">S No.</th>
                                    <th className="text-center">Plan</th>
                                    <th className="text-center">Plan Type</th>
                                    {section == appConstants.SECTION_INDICATIVE_QUOTE && <th className="text-center">Base Premium</th>}

                                    {/* <th className="text-center">Premium</th> */}
                                    <th className="text-center">Actions</th>

                                </tr>
                            </thead>

                            <tbody>
                                {currentPlans.map((result, index) => (
                                    <tr /*key={benefits.quoteCategoryBenefitId}*/ >
                                        <td >
                                            {<div className="text-center" id="Check1">
                                                <input type="checkbox" id={1} className="form-check-input"
                                                    checked={result.isChecked}
                                                    disabled={result.isRestricted}
                                                    onChange={value => handlePlansCheckboxChange(value, result.planId)}
                                                    value={1} />
                                            </div>}
                                        </td>
                                        <td> {(Number(index) + Number(1))} </td>
                                        <td> {result.planCode} - {result.planDescription}</td>
                                        <td> {result.planTypeName}</td>
                                        {section == appConstants.SECTION_INDICATIVE_QUOTE && <td> {result.basePremium} </td>}
                                        {/* <td> {result.Premium}</td> */}
                                        <td className="text-center">
                                            <div className='btn-group'>
                                                <button type="button" className="btn btn-secondary btn-sm" data-bs-toggle="modal" id="individualPlanTobModal1" data-bs-target="#individualPlanTobModal" title="View TOB"
                                                    disabled={result.isRestricted}
                                                    onClick={() => onDisplayCurrentPlanTOB(result.planId, result.planName, result.productName)}>
                                                    <i className="dripicons-preview"></i>
                                                </button>
                                                {section == appConstants.SECTION_INDICATIVE_QUOTE && (indicativeMemberList.length > 1 || (indicativeMemberList.length == 1 && indicativeMemberList[0].memberFirstName != null)) &&
                                                    <button type="button" className="btn btn-primary btn-sm" data-bs-container="#tooltip-container2"
                                                        data-bs-placement="bottom"
                                                        data-bs-toggle="modal" id="memberBasePremiumModalId" data-bs-target="#memberBasePremiumModal"
                                                        title="View Base Premium"
                                                        disabled={result.isRestricted}
                                                        onClick={() => onDisplayCurrentBasePremium(result.planId, result.productId)}>
                                                        <i className="mdi mdi-cash"></i>
                                                    </button>}
                                                <button type="button" className="btn btn-info btn-sm" data-bs-container="#tooltip-container2"
                                                    data-bs-placement="bottom"
                                                    data-bs-toggle="modal" /* id="individualPlanTobModal1465f65s465" data-bs-target="#individualPlanTobModal1465f65s465" */
                                                    title="Download TOB"
                                                    disabled={result.isRestricted}
                                                    onClick={() => onDownloadTOBFile(result?.tobFileName ?? null)}>
                                                    <i className="mdi mdi-download"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>))}

                            </tbody>
                        </table>
                    </div>}
                </div>

            </div>

        </>)
    }

    function renderPlanProduct() {

        let plans = productSelection?.planType ? productSelection.plansList.filter(p => p.portalPlanTypeId == Number(productSelection?.planType)) : productSelection.plansList
        console.log('productSelection', productSelection?.planType);

        let VisaEmirate =
            <select className={errors.visaEmirate ? 'form-select is-invalid' : 'form-select'}
                data-toggle="select2"
                id="visaEmirate"
                name="visaEmirate"
                disabled={true}
                {...register("visaEmirate",
                    { required: "Field Is Required", onChange: (e) => handleProductSelectionChange(e) })}
                value={productSelection.visaEmirate}
            >
                <option value="">-- Select Visa Emirate --</option>
                {masters.visaEmirateMasters.filter(emirate => !appConstants.VISA_EMIRATE_COUNTRY.includes(emirate.domainValue)
                ).map((res, index) => (
                    <option value={res.id} key={res.id}>
                        {res.name}
                    </option>
                ))}
            </select>
        let Network =
            <select className={errors.networkType ? 'form-select is-invalid' : 'form-select'}
                data-toggle="select2"
                id="networkType"
                name="networkType"
                // disabled={basicInfoNewEnq?.isRefertoUW}
                disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                {...register("networkType",
                    { onChange: (e) => handleProductSelectionChange(e) })}
                value={productSelection.networkType}
            >
                <option value="">-- Select Network --</option>
                {masters.networkMaster.map((res, index) => (
                    <option value={res.networkId} key={res.networkId}>
                        {res.networkName}
                    </option>
                ))}
                {/* {masters.networkMaster.filter(m => productSelection.plansList.map(p => p.portalPlanTypeId)).map((portalPlanType, index) => (
                    <option value={portalPlanType.domainValue} key={portalPlanType.domainValue}>
                        {portalPlanType.domainValueName}
                    </option>
                ))} */}
            </select>
        let PlanType =
            <select className={errors.planType ? 'form-select is-invalid' : 'form-select'}
                data-toggle="select2"
                id="planType"
                name="planType"
                // disabled={basicInfoNewEnq?.isRefertoUW}
                disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                {...register("planType",
                    { /* required: "Field Is Required",  */onChange: (e) => handleProductSelectionChange(e) })}
            //value={productSelection.planType}
            >
                <option value="">-- Select Plan Type --</option>
                {masters.portalPlanTypeMastersFilterd.filter(m => productSelection.plansList.map(p => p.portalPlanTypeId).includes(m.domainValue)).map((portalPlanType, index) => (
                    <option value={portalPlanType.domainValue} key={portalPlanType.domainValue}>
                        {portalPlanType.domainValueName}
                    </option>
                ))}
            </select>
        return (
            <>
                <div className="row g-2">
                    <div className="mb-2 col-md-1">
                    </div>
                </div >

                <div className="row g-2">
                    <div className="mb-2 col-md-12">
                        <div className="btn-group float-end" id="tooltip-container2">

                            <button type="button" className="btn" style={{ backgroundColor: '#ffa500' }}
                                title=" Compare Plans" onClick={() => onPlansComparison()}>
                                <i className="mdi mdi-compare-horizontal"></i>   Compare Plans
                            </button>
                        </div>
                    </div>
                </div>
                <form onSubmit={handleSubmit(onSubmit, onErrors)}>
                    <div className="row pb-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className="col-1 text-end">
                                <label htmlFor="visaEmirate" className="form-label w-100"><span className='text-danger me-1'>*</span></label>
                            </div>
                            <div className="col-3 text-start">
                                <label htmlFor="visaEmirate" className="form-label w-100">Visa Emirate</label>
                            </div>
                            <div className="col-8">
                                {VisaEmirate}
                                {errors.visaEmirate && <p className="text-danger fst-italic fs-6">{errors.visaEmirate.message}</p>}
                            </div>

                        </div>
                    </div>
                    <div className="row pb-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className="col-1 text-end">
                                {/* <label htmlFor="networkType" className="form-label w-100"><span className='text-danger me-1'>*</span></label> */}
                            </div>
                            <div className="col-3 text-start">
                                <label htmlFor="networkType" className="form-label w-100">Network</label>
                            </div>
                            <div className="col-8">
                                {Network}
                                {errors.networkType && <p className="text-danger fst-italic fs-6">{errors.networkType.message}</p>}
                            </div>
                        </div>
                    </div>
                    <div className="row pb-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className="col-1 text-end">
                                {/* <label htmlFor="visaEmirate" className="form-label w-100"><span className='text-danger'>*</span></label> */}
                            </div>
                            <div className="col-3 text-start">
                                <label htmlFor="visaEmirate" className="form-label w-100">{/* <span className='text-danger'>*</span> */} Plan Type</label>
                            </div>
                            <div className="col-8">
                                {PlanType}
                                {errors.visaEmirate && <p className="text-danger fst-italic fs-6">{errors.visaEmirate.message}</p>}
                            </div>


                        </div>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-hover table-custom">
                            <thead className="table-header">
                                <tr>

                                    <th>No.</th>
                                    <th> Plan Description</th>
                                    <th> Premium (AED)</th>
                                    <th> Plan Type</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            {plans.length != 0 ? (
                                <tbody>


                                    {plans.map((result, index) => (
                                        <tr key={result.srlNo} className="table-row">
                                            <td>
                                                <label>
                                                    <input type="checkbox" id={result?.planId} className="form-check-input"
                                                        checked={result.isChecked}
                                                        onChange={value => handleCheckBox(value, result?.portalPlanTypeId, result?.productId)}
                                                        disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                                                        value={result.srlNo ?? (Number(index) + Number(1))} />

                                                </label> {(Number(index) + Number(1))}

                                            </td>
                                            <td> {result.planDescription}</td>
                                            <td> {appUtilityFunctions.formatAmount(result.basePremium)} </td>
                                            <td> {result.planTypeName}  </td>
                                            <td className='align-middle col-md-1 '>
                                                <div className='d-flex justify-content-between'>
                                                    {/* <PolicyIcon style={{ color: 'orange', cursor: 'pointer' }} titleAccess="View TOB" onClick={() => onDisplayCurrentPlanTOB(result.planId, result.planName, result.productName)} />TOB
                                                    <PaymentsIcon style={{ color: 'green', cursor: 'pointer' }} titleAccess="View Base Premium Breakdown" onClick={() => onDisplayCurrentBasePremium(result.planId, result.productId)}/>Base Premium
                                                    <DownloadIcon style={{ color: 'blue', cursor: 'pointer' }} titleAccess="Download TOB" onClick={() => onDownloadTOBFile(result?.tobFileName ?? null)} />TOB */}

                                                    <div style={{ textAlign: 'center' }} onClick={() => onDisplayCurrentPlanTOB(result.planId, result.planName, result.productName)}>
                                                        <PolicyIcon
                                                            style={{ color: 'orange', cursor: 'pointer' }}
                                                            titleAccess="View TOB"

                                                        />
                                                        <div>View TOB</div>
                                                    </div>

                                                    <div style={{ textAlign: 'center' }} onClick={() => onDisplayCurrentBasePremium(result.planId, result.productId)}>
                                                        <PaymentsIcon
                                                            style={{ color: 'green', cursor: 'pointer' }}
                                                            titleAccess="View Base Premium Breakdown"

                                                        />
                                                        <div>Base Premium</div>
                                                    </div>

                                                    <div style={{ textAlign: 'center' }} onClick={() => onDownloadTOBFile(result?.tobFileName ?? null)}>
                                                        <DownloadIcon
                                                            style={{ color: 'blue', cursor: 'pointer' }}
                                                            titleAccess="Download TOB"

                                                        />
                                                        <div>Download TOB</div>
                                                    </div>
                                                    &nbsp;
                                                    <div style={{ textAlign: 'center' }} onClick={() => onDownloadNetFile(result?.netFileName ?? null)}>
                                                        <DownloadIcon
                                                            style={{ color: 'blue', cursor: 'pointer' }}
                                                            titleAccess="Download Network"

                                                        />
                                                        <div>Download Network</div>
                                                    </div>

                                                </div>
                                            </td>


                                        </tr>
                                    ))}
                                </tbody>
                            ) : (
                                <tbody>
                                    <tr>
                                        <td colSpan="8" className="text-center">
                                            <div className="alert alert-warning">No Plans Found...</div>
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </div>
                    <div ref={refBasePremuimBreak}>
                        {modalState?.memberBasePremModal && renderMemberBasePremuim()}
                    </div>
                    <div ref={refPlanTob}>
                        {modalState?.planTobModal && <PlanTOB />}
                    </div>

                    <div ref={refPlanCompare}>
                        {modalState?.planCompare && <PlanCompare />}
                    </div>


                    <Box sx={{ marginTop: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            className='mx-2'
                            variant="outlined"
                            type='button'
                            color="secondary"
                            onClick={handleBack}
                            startIcon={<ArrowBackIcon />}
                            disabled={activeStep === 0}
                        >
                            Back
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            // onClick={handleNext}
                            endIcon={
                                <ArrowForwardIcon />
                            }
                        >
                            Next
                        </Button>


                    </Box>
                </form>

            </>
        )
    }
    function renderMemberBasePremuim() {

        return (
            <>


                <div className="table-responsive">
                    <table className="table table-hover table-custom">
                        <thead className="table-header">
                            <tr>
                                {/* <th>
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                id="CheckAll"
                                                className="form-check-input"
                                                onChange={value => handleAllMemberCheckboxChange(value)}
                                            />
                                        </div>
                                    </th> */}
                                <th>No.</th>
                                <th> Member Name	</th>
                                <th> Gender</th>
                                <th> Marital Status</th>
                                <th> Date Of Birth</th>
                                <th> Relation</th>
                                <th> Premium (AED)</th>

                            </tr>
                        </thead>
                        {memberBasePrem.length != 0 ? (
                            <tbody>
                                {memberBasePrem.map((result, index) => (
                                    <tr key={result.srlNo} className="table-row">
                                        <td> {(Number(index) + Number(1))} </td>
                                        <td> {result.memberFullName}</td>
                                        <td> {result.gender} </td>
                                        <td> {result.maritalStatus}  </td>
                                        <td>   {appUtilityFunctions.formatDate(result.dateOfBirth)}  </td>
                                        <td> {result.relation}  </td>
                                        <td> {appUtilityFunctions.formatAmount(result.basePremium)}     </td>



                                    </tr>
                                ))}
                            </tbody>
                        ) : (
                            <tbody>
                                <tr>
                                    <td colSpan="8" className="text-center">
                                        <div className="alert alert-warning">No Plans Found...</div>
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>

            </>
        )
    }
    return (
        <>
            <ul className="nav nav-tabs nav-bordered mb-1">
            </ul>
            <div className="row g-2">
                <div className="mb-1 col-md-12">
                </div>
            </div>
            <div className="collapse show" id="CollapseBasicMemberInfoQuote">
                {renderPlanProduct()}


            </div >
        </>

    )
}